export default __webpack_public_path__ + "static/media/CRO.114ed682.svg";